export const C_REDIRECTION_MANAGER_KEYS = {
    LIST_CHORES_EMAIL : 'listChoresEmail',
}